import { render, staticRenderFns } from "./xieYiDes.vue?vue&type=template&id=74f568ae&scoped=true"
import script from "./xieYiDes.vue?vue&type=script&lang=js"
export * from "./xieYiDes.vue?vue&type=script&lang=js"
import style0 from "./xieYiDes.vue?vue&type=style&index=0&id=74f568ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f568ae",
  null
  
)

export default component.exports